import type { IClientMicrocredit } from '@src/@types/clienttypes';
import { isFullDealOrganization } from 'shared/config/fullDealOrganizationIds';

export const isShowDetailsCard = (card: IClientMicrocredit) => {
  if (!card?.organization) {
    return false;
  }

  /**
   * У full deal мы не проверяем на статус === 'active'
   * Пример задачи - https://sravni-corp.atlassian.net/browse/MFO-1222
   */
  if (isFullDealOrganization(card.organization._id)) {
    return true;
  }

  return card.organization.status === 'active';
};
